import React from 'react';

import {Layout, WarningIcon} from '@phonectas/unifon-ui-kit';
import {
	StyledUnifonWarningDiv,
	StyledUnifonWarningLayout,
	StyledUnifonWarningText,
} from 'containers/ThreeSixty/components/CustomerWarnings/styled';

interface Props {
    warnings?: string | string[];
	endBorderRadius?: boolean;
    variant?: 'info' | 'warning' | 'error';
}

const SlideInWarnings: React.FC<Props> = ({
	warnings,
	endBorderRadius = false,
	variant = 'error',
}) => {
	if (!warnings || (Array.isArray(warnings) && warnings.length === 0)) {
		return null;
	}

	const warningList = Array.isArray(warnings) ? warnings : [warnings];

	return (
		<Layout
			direction="column"
			nowrap
			fullWidth
			gap="xs"
			style={{padding: '0px'}}
		>
			{warningList.map((warning, index) =>
				<StyledUnifonWarningLayout
					key={index}
					$delay={index}
					$variant={variant}
					$endBorderRadius={endBorderRadius ? true : false}
				>
					<StyledUnifonWarningDiv nowrap $delay={index}>
						<WarningIcon size="lg" color="white"/>
						<StyledUnifonWarningText>
							{warning}
						</StyledUnifonWarningText>
					</StyledUnifonWarningDiv>
				</StyledUnifonWarningLayout>
			)}
		</Layout>
	);
}

export default SlideInWarnings;